module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8"
  }, [_c('h3', [_vm._v("The timeline")]), _vm._v(" "), _c('route-timeline')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('h3', [_vm._v("The counter")]), _vm._v(" "), _c('the-counter')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ba17cc02"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Dashboard.vue
// module id = 113
// module chunks = 1